import { loadModules } from 'esri-loader';
import { bootstrapJSAPI } from '../../utils/esriLoader';

export default class AuthManager {
  constructor(env, portalUrl, jsapiUrl, jsapiV4, loginWithPopup) {
    this.env = env;
    if (this.env.is_next) {
       this.appId = env.REACT_APP_ID_NEXT;
    } else {
       this.appId = env.REACT_APP_ID;
    }
    this.appId = env.REACT_APP_ID;
    this.portalUrl = portalUrl;
    this.jsapiUrl = jsapiUrl;
    this.jsapiV4 = jsapiV4;
    this.loginWithPopup = loginWithPopup;
  }

  startup = () => {
    return new Promise((resolve, reject) => {
      bootstrapJSAPI(this.portalUrl, this.jsapiUrl, this.jsapiV4)
        .then(success => {
          loadModules([
            'esri/identity/IdentityManager',
            'esri/identity/OAuthInfo'
          ]).then(([esriId, OAuthInfo]) => {
            this.idManager = esriId;

            const observerId = localStorage.getItem('observer_id');
            if (observerId) {
              // if auth was persisted, just use that
              this.idManager.initialize(observerId);
            } else {
              this.idManager.useSignInPage = !this.loginWithPopup;
              this.oAuthInfo = new OAuthInfo({
                appId: this.appId,
                portalUrl: this.portalUrl,
                popup: this.loginWithPopup
              });
              this.idManager.registerOAuthInfos([this.oAuthInfo]);
            }

            resolve();
          });
        })
        .catch(err => {
          reject();
        });
    });
  };

  login = () => {
    return new Promise((resolve, reject) => {
      this.checkLogin().then(
        success => {
          this.getUser().then(resolve, reject);
        },
        failed => {
          this.doLogin().then(user => resolve(user), error => reject(error));
        }
      );
    });
  };

  checkLogin = () => {
    return new Promise((resolve, reject) => {
      const sharingUrl = this.portalUrl + '/sharing';

      this.idManager
        .checkSignInStatus(sharingUrl)
        .then(credential => {
          this.persistAuth();
          this.getUser().then(resolve, reject);
        })
        .otherwise(e => {
          reject('User is not logged in');
        });
    });
  };

  doLogin = () => {
    return new Promise((resolve, reject) => {
      const sharingUrl = this.portalUrl + '/sharing';

      this.idManager
        .getCredential(sharingUrl, { oAuthPopupConfirmation: false })
        .then(credential => {
          this.getUser().then(resolve, reject);
        })
        .otherwise(reject);
    });
  };

  getUser = () => {
    return new Promise((resolve, reject) => {
      loadModules(['esri/portal/Portal']).then(([Portal]) => {
        let portal = new Portal({
          url: this.portalUrl,
          authMode: 'immediate'
        });
        portal
          .load()
          .then(() => {
            this.user = portal.user;
            this.user
              .fetchGroups()
              .then(groups => {
                this.user.groups = groups;
                this.user.isAdmin = this.getAdminStatus(this.user);
                this.user.isAuthorized = this.getAuthorizedStatus(this.user);
                resolve(this.user);
              })
              .otherwise(reject);
          })
          .otherwise(reject);
      });
    });
  };

  persistAuth() {
    // persist auth to a cookie for cross-page goodness
    const json = this.idManager.toJSON();
    localStorage.setItem('observer_id', JSON.stringify(json));
  }

  logout = () => {
    loadModules(['dojo/cookie']).then(([cookie]) => {
      // dojo cookies hates me
      cookie('esri_auth', '{observer: "logout"}', {
        expire: -1,
        expires: -1,
        path: '/'
      });
      this.idManager.destroyCredentials();

      // it seems strange to sign out of eaglei even for outside org users,
      // but this works for both eaglei and outside users, whereas signing out of
      // generic arcgis.com only works for outside users.
      window.api.logout().then(
        success => {
          this.persistAuth(this.idManager.destroyCredentials());
          window.location.reload();
        },
        error => {
          console.error(error);
        }
      );
    });
  };

  getToken = () => {
    return this.idManager.findCredential(this.portalUrl, this.user.username)
      .token;
  };

  getAdminStatus = user => {
    const { adminGroupId } = this.env;
    if (!adminGroupId) return true;

    const adminGroup = user.groups.filter(group => group.id === adminGroupId);
    return adminGroup.length > 0;
  };

  getAuthorizedStatus = user => {
    const { userGroupId } = this.env;
    if (!userGroupId) return true;

    const userGroup = user.groups.filter(group => group.id === userGroupId);
    return userGroup.length > 0;
  };
}



// WEBPACK FOOTER //
// ./src/esri/auth/AuthManager.js